import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: {
    // Add reducers here
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export const useAppDispatch = () => store.dispatch;
export const useAppSelector = (selector) => selector(store.getState());